module.exports = __webpack_public_path__ + "static/media/food.b791660e.svg";